import { useEffect, useState } from "react";
import { IStandard } from "@/search/NewSearchPageMVP/types/IStandard";

export const useStandardsSetFilter = (standards: IStandard[]) => {
  const [currentStandards, setCurrentStandards] = useState<IStandard[]>(
    standards as IStandard[],
  );
  const [filteredStandards, setFilteredStandards] =
    useState<IStandard[]>(standards);
  const [selectedSubjectFilter, setSelectedSubjectFilter] =
    useState<string>("-");
  const [selectedDateFilter, setSelectedDateFilter] = useState<string>("-");
  const [availableSubjects, setAvailableSubjects] = useState<string[]>([]);
  const [availableDates, setAvailableDates] = useState<string[]>([]);

  useEffect(() => {
    const getAvailableFilters = () => {
      const subjects = Array.from(
        new Set(
          currentStandards
            .filter(
              (standard) =>
                selectedDateFilter === "-" ||
                standard.display_fields.document_adopt_year.toString() ===
                  selectedDateFilter,
            )
            .map(
              (standard) => standard.display_fields.document_primary_subject,
            ),
        ),
      );
      setAvailableSubjects(subjects);

      const dates = Array.from(
        new Set(
          currentStandards
            .filter(
              (standard) =>
                selectedSubjectFilter === "-" ||
                standard.display_fields.document_primary_subject ===
                  selectedSubjectFilter,
            )
            .map((standard) =>
              standard.display_fields.document_adopt_year.toString(),
            ),
        ),
      );
      setAvailableDates(dates);
    };

    const getFilteredStandards = () => {
      let filteredStd = currentStandards;

      filteredStd =
        selectedSubjectFilter === "-"
          ? filteredStd
          : filteredStd.filter(
              (standard) =>
                standard.display_fields.document_primary_subject ===
                selectedSubjectFilter,
            );

      filteredStd =
        selectedDateFilter === "-"
          ? filteredStd
          : filteredStd.filter(
              (standard) =>
                standard.display_fields.document_adopt_year.toString() ===
                selectedDateFilter,
            );

      setFilteredStandards(filteredStd);
    };

    getAvailableFilters();
    getFilteredStandards();
  }, [currentStandards, selectedSubjectFilter, selectedDateFilter, standards]);

  return {
    currentStandards,
    setCurrentStandards,
    filteredStandards,
    setFilteredStandards,
    selectedSubjectFilter,
    setSelectedSubjectFilter,
    selectedDateFilter,
    setSelectedDateFilter,
    availableDates,
    availableSubjects,
  };
};
